import gql from 'graphql-tag';
import { apolloClient, cache } from '../../src/apollo';

function createQuoteRequest(cart, comment, quoteRequestSuccessCallback) {
  const { cartId, version } = cart;
  const query = gql`
    mutation createQuoteRequest(
      $draft: MyQuoteRequestDraft!
    ) {
      createMyQuoteRequest(draft: $draft) {
        id
        version,
        comment
      }
    }
  `;
  apolloClient
    .mutate({
      mutation: query,
      variables: {
        draft: {
          cartId: cartId,
          cartVersion: version,
          comment: comment,
        },
      },
    })
    .then((result) => {
      if(quoteRequestSuccessCallback) {
        quoteRequestSuccessCallback(result.data)
      }
    })
    .catch((er) => console.error(er));
}

export function deleteCartAfterQuoteRequest(cart) {
  return apolloClient.mutate({
    mutation: gql`
      mutation deleteCart(
        $version: Long!
        $id: String!
      ) {
        deleteMyCart(version: $version, id: $id) {
          id
        }
      }
    `,
    variables: {
      id: cart.cartId,
      version: cart.version,
    },
  }).then((res)=>{
    cache.evict({ id: 'activeCart' });
    cache.gc();
    return res;
  })
}

export function acceptFinalQuote(quoteId, quoteVersion) {
  return apolloClient.mutate({
    mutation: gql `
      mutation updateMyQuote(
        $version: Long!,
        $actions: [MyQuoteUpdateAction!]!,
        $id: String!
      ) {
        updateMyQuote(version: $version, actions: $actions, id: $id) {
          quoteState
        }
      }
    `,
    variables: {
      id: quoteId,
      version: parseInt(quoteVersion),
      actions: {
        changeMyQuoteState: {
          quoteState: "Accepted"
        }
      }
    }
  }).then(res => {
    return res;
  })
}

export function changeQuotationCartLineItemQuantity(cartId, cartVersion, lineItemId, qty) {
  return apolloClient.mutate({
    mutation: gql`
      mutation UpdateCart(
        $version: Long!,
        $actions: [CartUpdateAction!]!,
        $id: String
      ) {
        updateCart(version: $version, actions: $actions, id: $id) {
          id
          version         
        }
      }
    `,
    variables: {
      id: cartId,
      version: parseInt(cartVersion),
      actions: [
        {
          changeLineItemQuantity: {
            lineItemId: lineItemId,
            quantity: parseInt(qty)
          }
        }
      ]
    }
  })
}

export function deleteQuotationCartLineItem(cartId, cartVersion, lineItemId) {
  return apolloClient.mutate({
    mutation: gql`
      mutation UpdateCart(
        $version: Long!,
        $actions: [CartUpdateAction!]!,
        $id: String
      ) {
        updateCart(version: $version, actions: $actions, id: $id) {
          id
          version         
        }
      }
    `,
    variables: {
      id: cartId,
      version: parseInt(cartVersion),
      actions: [
        {
          removeLineItem: {
            lineItemId: lineItemId
          }
        }
      ]
    }
  });
}

export function addDirectDiscount(cartId, cartVersion, discounts) { 
  return apolloClient.mutate({
    mutation: gql`
      mutation UpdateCart(
        $version: Long!,
        $actions: [CartUpdateAction!]!,
        $id: String
      ) {
        updateCart(version: $version, actions: $actions, id: $id) {
            id
            version
        }
      }
    `,
    variables: {
      id: cartId,
      version: parseInt(cartVersion),
      actions: [
        {
          setDirectDiscounts: {
            discounts: [
              ...discounts
            ],
          },
        },
      ],
    },
  });
}

export function createFinalQuotation(stagedQuoteId, stagedQuoteVersion) {
  return apolloClient.mutate({
        mutation: gql `
            mutation CreateQuote($draft: QuoteDraft!) {
                createQuote(draft: $draft) {
                    id
                    version
                }
            }
        `,
        variables: {
            draft: {
                stagedQuote: {
                    typeId : "staged-quote",
                    id : stagedQuoteId
                },
                "stagedQuoteVersion": parseInt(stagedQuoteVersion)
            }
        }
    })
    .then((finalQuoteResponse)=>{
      return finalQuoteResponse;
    });
}

export const changeQuoteRequestState = (quoteVersion, quoteId, quoteRequestState) => {
  return apolloClient.mutate({
      mutation: gql `
          mutation UpdateQuoteRequest($version: Long!, $actions: [QuoteRequestUpdateAction!]!, $id: String) {
              updateQuoteRequest(version: $version, actions: $actions, id: $id) {
                  quoteRequestState
                  id
                  version
              }
          }
      `,
      variables: {
          version: parseInt(quoteVersion),
          id: quoteId,
          actions: {
              changeQuoteRequestState: {
                  quoteRequestState: quoteRequestState
              }
          }
      }
  })
}

export const setLineItemPrice = (cartId, cartVersion, action) => {
  return apolloClient.mutate({
    mutation: gql`
      mutation setLineItemPrice($version: Long!, $id: String, $actions: [CartUpdateAction!]!) {
        updateCart(version: $version, id: $id, actions: $actions) {
            id
            version
            lineItems {
                id
                productId
                price {
                    id
                    value {
                        type
                        centAmount
                    }
                }
            }
        }
    }
    `,
    variables: {
      id: cartId,
      version: parseInt(cartVersion),
      actions: action
    }
  });
}
export default createQuoteRequest;
